<template>
  <el-form ref="form" :model="config" :rules="rules" label-width="100px">

    <el-form-item label="小数位长度限制" v-if="isdecimal">
      <el-input type="number" class="h-40 w-200" v-model.number="config.decimal" :disabled="disabled" @blur="setFromMax('decimal')"></el-input>
      <div class="form-tips">0为输入整数，系统自动补齐两位小数；</div>
    </el-form-item>
    <el-form-item label="最小长度限制" prop="write_min" v-if="!isdecimal">
      <el-input type="number" v-model.number="config.write_min" class="h-40 w-200" :disabled="disabled" @blur="setFromMax('min')"></el-input>
      <div class="form-tips">填0代表不限制</div>
    </el-form-item>

    <el-form-item label="最大长度限制" prop="write_max">
      <el-input type="number" v-model.number="config.write_max" class="h-40 w-200" :disabled="disabled" @blur="setFromMax('max')"></el-input>
      <div class="form-tips" v-if="maxCount != undefined">最大长度不能超过{{ maxCount }}，包括中英文和数字</div>
    </el-form-item>
  </el-form>
</template>

<script>
  export default {
    props: ['config', 'limitMin', 'limitMax', 'maxCount', 'disabled', 'isdecimal', 'isBank'],
    data() {
      return {
        rules: {
          write_min: [],
          write_max: [],
          decimal: []
        }
      }
    },
    created() {
      let needMin = { type: 'number', required: true, message: '请输入最小长度限制', trigger: 'blur' }
      let needMax = { type: 'number', required: true, message: '请输入最大长度限制', trigger: 'blur' }
      if (this.limitMin) {
        this.rules.write_min.push(needMin)
      }
      if (this.limitMax) {
        this.rules.write_max.push(needMax)
      }

      let vaildMin = { validator: this.vaildMin, trigger: 'blur' }
      let vaildMax = { validator: this.vaildMax, trigger: 'blur' }
      let checkMaxCount = { validator: this.checkMaxCount, trigger: 'blur' }
      this.rules.write_min.push(vaildMin)
      this.rules.write_max.push(vaildMax)
      this.rules.write_max.push(checkMaxCount)
      this.rules.decimal.push(checkMaxCount)
    },
    methods: {
      vaildMin(rule, value, callback) {
        if (this.config.write_max !== '' && value && value > this.config.write_max) {
          callback('最小长度必须小于最大长度')
        } else {
          callback()
        }
      },
      vaildMax(rule, value, callback) {
        if (this.config.write_min && value !== '' && value < this.config.write_min) {
          callback('最大长度必须大于最小长度')
        } else {
          callback()
        }
      },
      checkMaxCount(rule, value, callback) {
        if (this.maxCount != undefined && this.config.write_max > this.maxCount) {
          callback(`最大长度不能超过${this.maxCount}`)
        } else {
          callback()
        }
      },
      setFromMax(type) {
        if (type == 'min') {
          if (this.config.write_min > this.maxCount) {
            this.config.write_min = this.maxCount
          }
        } else if (type == 'max') {
          if (this.config.write_max > this.maxCount) {
            this.config.write_max = this.maxCount
          }
        } else if (type == 'decimal') {
          if (this.config.decimal == "" || this.config.decimal < 0) {
            this.config.decimal = 0
          }
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// textlenConfig.vue?5a992de5